module.exports = __webpack_public_path__ + "static/media/EverydayCreativity.b6620e24.png";